import { fetchFresh } from "./fetchFresh"

export const SUPER_ADMIN_SESSION_EXPIRED_EVENT = "superadmin-session-expired"
const HTTP_UNAUTHORIZED = 401
const INVALID_SYSTEM_TOKEN_ERROR = 2801

const hasBearerAuthorization = (headers?: HeadersInit) => {
	if (!headers) return false
	const authorization = new Headers(headers).get("Authorization")
	return Boolean(authorization?.startsWith("Bearer "))
}

export const superAdminFetch: typeof fetch = async (input, init) => {
	const response = await fetchFresh(input, init)

	if (!hasBearerAuthorization(init?.headers)) return response

	let hasExpiredSession = response.status === HTTP_UNAUTHORIZED
	if (!hasExpiredSession) {
		try {
			const payload = await response.clone().json() as { error?: { code?: number | string } }
			hasExpiredSession = Number(payload.error?.code) === INVALID_SYSTEM_TOKEN_ERROR
		} catch {
			// Non-JSON responses cannot carry the API's invalid-token error code.
		}
	}

	if (hasExpiredSession) {
		window.dispatchEvent(new Event(SUPER_ADMIN_SESSION_EXPIRED_EVENT))
	}

	return response
}
